export default __webpack_public_path__ + "static/media/kes.dbfd053f.png";